const PbxxRecord = require('../pbxx_record')

module.exports = class FacebookShare extends PbxxRecord {
  static get class_name() {
    return 'FacebookShare'
  }
}
